import { createUseTrackScreen } from '@bluecodecom/tracking';

import { ScreenName, TrackingEvents, trackingService } from '../../service';

/**
 * Reports a displayed screen twice — the catalogued universal `screen_displayed`
 * and this app's legacy `PayAtPump: <Screen>: Opened` — for as long as the
 * migration needs both (catalog rule `dual-fire`).
 *
 * Pass a nullish screen name for a render that is not going to display the
 * screen; both events are then suppressed together. The behaviour lives in
 * `libs/tracking` (`createUseTrackScreen`), this only binds pay-at-pump's
 * service and screen vocabulary to it.
 */
const useTrackScreen = createUseTrackScreen<ScreenName, TrackingEvents>(
  trackingService,
);

export default useTrackScreen;
